import React from 'react';
import { compose } from 'redux';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import __DEPRECATED_defineResources from 'dpl/shared/fetching/deprecated/defineResources';
import { newsletterSignupResourceDefinition } from 'dpl/shared/utils/tptConnectResourceDefinitions';
import { CONSTRAINT_TYPES } from 'dpl/shared/validations/constraints';
import withFormCapabilities from 'dpl/form/decorators/withFormCapabilities';
import NewsletterForm from 'dpl/components/NewsletterForm';
import useBreederProfileMobileLayout from 'dpl/components/BreederProfile/hooks/useBreederProfileMobileLayout';

/** @param {Record<string, any>} props */
function NewsletterFormContainer({ pageName = null, ...rest }) {
  const props = { pageName, ...rest };
  const { isNewMobileLayout } = useBreederProfileMobileLayout();

  if (pageName === 'breeder_profiles_show' && isNewMobileLayout) {
    return null;
  }

  return <NewsletterForm {...props} />;
}

NewsletterFormContainer.propTypes = {
  pageName: PropTypes.string
};

export default compose(
  __DEPRECATED_defineResources(() => ({
    newsletterData: newsletterSignupResourceDefinition()
  })),
  withFormCapabilities(() => ({}), {
    mapPropsAndStateToValidationSchema: (_, { email }) => ({
      email: email ? CONSTRAINT_TYPES.EMAIL : CONSTRAINT_TYPES.TEXT
    }),
    onSubmit: (props, formStateForSubmission) =>
      props.newsletterData.submit({
        user: formStateForSubmission
      })
  }),
  connect(({ server }) => ({
    pageName: server.pageName || ''
  }))
)(NewsletterFormContainer);
